/**
 * API "me" (source de vérité métier).
 * Responsabilité: centraliser les endpoints liés à l'utilisateur connecté et aux clients accessibles.
 */

import { baseApi } from 'core/api/base'
import { IApiClientMe, IApiUtilisateurMe } from 'core/interfaces/Me'

const CLIENTS_ME_ENDPOINT = '/clients/me'
const UTILISATEURS_ME_ENDPOINT = '/utilisateurs/me'

export const meApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getMyClients: builder.query<IApiClientMe[], void>({
      query: () => ({ url: CLIENTS_ME_ENDPOINT }),
      providesTags: [{ type: 'Client', id: 'ME' }],
    }),
    getMyUser: builder.query<IApiUtilisateurMe, void>({
      query: () => ({ url: UTILISATEURS_ME_ENDPOINT }),
      providesTags: [{ type: 'KeycloakUser', id: 'ME' }],
    }),
  }),
})

export const { useGetMyClientsQuery, useGetMyUserQuery } = meApi
